<template>
    <v-card class="elevation-10">
        <v-card-title>
            <v-container grid-list-md text-xs-center>
                <v-layout row wrap>
                    <v-flex xs4>
                        <v-autocomplete
                                v-model="country_id"
                                :items="countries"
                                label="Country"
                                item-text="name"
                                item-value="id"
                                v-on:change="state_id = null, getStates()"
                                clearable
                        >
                        </v-autocomplete>
                    </v-flex>
                    <v-flex xs4>
                        <v-autocomplete
                                v-model="state_id"
                                :items="states"
                                label="States"
                                item-text="name"
                                item-value="id"
                                clearable
                        >
                        </v-autocomplete>
                    </v-flex>
                    <v-flex xs4>
                        <v-text-field
                                v-model="search"
                                append-icon="search"
                                label="Search"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card-title>
        <v-data-table
                :headers="headers"
                :items="clients.data"
                :search="search"
                :pagination.sync="pagination"
                hide-actions
                :loading="loading"
                :total-items="8"
                v-on:update:pagination="ordenar"
        >
            <template slot="items" slot-scope="props">
                <tr>
                    <td @click="ver(props.item.id, false)" @contextmenu.prevent="ver(props.item.id, true)" class="text-xs">{{ props.item.company_name }}</td>
                    <td @click="ver(props.item.id, false)" @contextmenu.prevent="ver(props.item.id, true)">{{ props.item.name }}</td>
                    <td @click="ver(props.item.id, false)" @contextmenu.prevent="ver(props.item.id, true)" class="text-xs" >{{ props.item.email }}</td>
                    <td @click="ver(props.item.id, false)" @contextmenu.prevent="ver(props.item.id, true)" class="text-xs">{{ props.item.country }}</td>
                    <td @click="ver(props.item.id, false)" @contextmenu.prevent="ver(props.item.id, true)" class="text-xs">{{ props.item.state }}</td>
                    <td class="layout px-0 align-center">
                        <v-menu
                                transition="slide-y-transition"
                                bottom
                                left
                        >
                            <v-btn
                                    slot="activator"
                                    color="primary"
                                    dark
                                    fab
                                    flat
                            >
                                <v-icon>settings</v-icon>
                            </v-btn>
                            <v-list>
                                <v-list-tile>
                                    <v-btn flat block v-on:click="deleteItem(props.item.id)"><v-icon left>mdi-delete-circle</v-icon>Delete</v-btn>
                                </v-list-tile>
                                <!-- <v-list-tile>
                                    <v-btn flat block><v-icon left>email</v-icon>Restore password</v-btn>
                                </v-list-tile> -->
                            </v-list>
                        </v-menu>
                    </td>
                </tr>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
            </v-alert>
        </v-data-table>
        <div class="text-xs-center pt-4 pb-4" v-if="clients.data">
            <v-pagination
                    v-model="page"
                    :length="clients.meta.last_page"
                    color="secondary"
                    circle
                    :total-visible="7"
                    @input="setPage"
            ></v-pagination>
            <p class="subtitle" @click="exportar">Showing {{ clients.meta.from }} to {{ clients.meta.to }} of {{ clients.meta.total }} entries</p>
        </div>
    </v-card>
</template>

<script>
    import { BASE } from '../../../config';

    export default {
        data () {
            return {
                search: null,
                page: null,
                last_page: null,
                pagination: {},
                loading: true,
                headers: [
                    { text: 'Company name', align: 'left', value: 'company_name', sortable: true },
                    {
                        text: 'Name',
                        sortable: true,
                        value: 'name'
                    },
                    { text: 'Email', value: 'email', sortable: true },
                    { text: 'Country', value: 'country', sortable: true },
                    { text: 'State', value: 'state', sortable: true },
                    { text: 'Actions', value: 'action', sortable: false }
                ],
                clients: [],
                direction: 'left',
                fab: [],
                fling: false,
                hover: false,
                tabs: null,
                top: false,
                right: true,
                bottom: true,
                left: false,
                transition: 'slide-x-transition',
                states: [],
                countries: [],
                state_id: null,
                country_id: null,
                sortBy: 'company_name',
                order: 'asc',
                BASE: BASE,
                download_token: null,
                count: 0
            }
        },
        created: function() {
            this.getCountries();
            this.checkUser();
            this.setSectionTitle();
            this.setQueryParams();
            this.getClients();
            this.debouncedGetClients = _.debounce(this.getClients, 500)
        },
        computed: {
            export () {
                return this.BASE + 'clients/export?state_id=' + this.state_id + '&country_id=' + this.country_id + '&sortBy=' + this.sortBy + '&order=' + this.order + '&download_token=' + this.download_token
            }
        },
        watch: {
            search: function () {
                this.loading = true;
                this.$router.push({ query: Object.assign({}, this.$route.query, { search: this.search }) });
                this.debouncedGetClients();
            },
            last_page: function () {
                if (this.page > this.clients.meta.last_page) {
                    this.page = 1;
                }
            },
            state_id: function () {
                if (this.state_id == undefined) {
                    this.state_id = null;
                }
                this.$router.push({ query: Object.assign({}, this.$route.query, { state_id: this.state_id }) });
                this.debouncedGetClients();
            },
            country_id: function () {
                if (this.country_id == undefined) {
                    this.country_id = null;
                }
                this.$router.push({ query: Object.assign({}, this.$route.query, { country_id: this.country_id }) });
                this.debouncedGetClients();
            }
        },
        methods : {
            setQueryParams() {
                if (this.$route.query.search) {
                    this.search = this.$route.query.search;
                }
                if (this.$route.query.state_id) {
                    this.state_id = parseInt(this.$route.query.state_id);
                }
                if (this.$route.query.country_id) {
                    this.country_id = parseInt(this.$route.query.country_id);

                    this.getStates();
                }
            },
            exportar () {
                var self = this;
                setTimeout(function(){
                    self.reset();
                }, 800);
                this.count++;
                if (this.count >= 3) {
                    window.open(this.export);
                }
            },
            reset () {
                this.count = 0;
            },
            checkUser() {
                this.$store.dispatch('checkAccessToken').then((res) => {
                    this.download_token = this.$store.getters.getUser.download_token;
                }).catch((error) => {

                });
            },
            ordenar (payload) {
                this.sortBy = payload.sortBy;
                if (payload.descending) {
                    this.order = 'desc';
                } else {
                    this.order = 'asc';
                }
                this.getClients();
            },
            ver(id, blank) {
                if (! blank) {
                    this.$router.push({ name: 'admin.clients.detail', params : { id : id } });
                } else {
                    let route = this.$router.resolve({ name: 'admin.orders.detail', params : { id : id } });
                    window.open(route.href, '_blank');
                }

            },
            setSectionTitle () {
                this.$store.dispatch('setSectionTitle', {
                    title: 'Clients list.'
                });
            },
            deleteItem (id) {
                this.$confirm('Do you really want to delete?').then(res => {
                    if (res == true) {
                        this.$store.dispatch('deleteClient', {
                            id: id
                        }).then((res) => {

                            this.getClients();

                        }).catch((error) => {

                        });
                    }
                })
            },
            setPage (page) {
                this.page = page;
                this.getClients();
            },
            getClients () {
                var params = {
                    filters : {
                        search: this.search,
                        page: this.page,
                        state_id: this.state_id,
                        country_id: this.country_id,
                        sortBy: this.sortBy,
                        order: this.order
                    }
                };
                this.$store.dispatch('getClients', params).then((res) => {
                    this.clients = res.data;
                    this.loading = false;
                    this.page = res.data.meta.current_page;
                    this.last_page = res.data.meta.last_page;
                    this.loading = false;
                }).catch((error) => {

                });
            },
            getStates () {
                this.$store.dispatch('getSelectState', {
                    id: this.country_id
                }).then((res) => {

                    this.states = res.data;

                }).catch((error) => {

                });
            },
            getCountries () {
                this.$store.dispatch('getSelectCountry').then((res) => {

                    this.countries = res.data;

                }).catch((error) => {

                });

            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/clients/ListComponent.vue